<div class="com-popup">
    <div class="warn-pop com-pop-box">
        <div class="wp-txt-box">
            <div class="wp-title font18-sem">{{noteTitle | acpText}}</div>
            <ng-container *ngIf="innerFlag else GenHtml">
                <div class="wp-desc font14-reg" [innerHTML]="warnDesc | acpText"></div>
            </ng-container>
            <ng-template #GenHtml>
                <div class="wp-desc font14-reg">{{warnDesc | acpText}}</div>
            </ng-template>
        </div>
        <div class="wp-btn-line">
            <div class="wp-btn-ok font16-sem" (click)="btnAction('ok')">{{btnTxt | acpText}}</div>
            <ng-conatiner *ngIf="showBtn2">
                <div class="wp-btn-cancel font16-sem" (click)="btnAction('cancel')">{{btnTxt2 | acpText}}</div>
            </ng-conatiner>
        </div>
    </div>
</div>